"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _input = require("../../input");
var _BlockSubtitle = _interopRequireDefault(require("../../title/BlockSubtitle"));
var _button = require("../../button");
var _StepperMember = _interopRequireDefault(require("./StepperMember.style"));
var _StepperValueHeader = _interopRequireDefault(require("./StepperValueHeader"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var StepperMember = /*#__PURE__*/function (_React$Component) {
  _inherits(StepperMember, _React$Component);
  var _super = _createSuper(StepperMember);
  function StepperMember(props) {
    var _this;
    _classCallCheck(this, StepperMember);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "onCustomLabelAdd", function () {
      _this.setState({
        isCustomLabel: true
      });
      _this.props.ruleChange({
        label: ''
      });
    });
    _defineProperty(_assertThisInitialized(_this), "onCustomLabelRemove", function () {
      _this.setState({
        isCustomLabel: false
      });
      _this.props.ruleChange({
        label: null
      });
    });
    _defineProperty(_assertThisInitialized(_this), "onLabelChange", function (event) {
      return _this.props.ruleChange({
        label: event.target.value
      });
    });
    _defineProperty(_assertThisInitialized(_this), "onValueChange", function (event) {
      return _this.props.ruleChange({
        value: event.target.value,
        type: 'numeric'
      });
    });
    _this.state = {
      isCustomLabel: !!props.data.label
    };
    return _this;
  }
  _createClass(StepperMember, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        labels = _this$props.labels,
        index = _this$props.index,
        data = _this$props.data,
        removeStep = _this$props.removeStep,
        setHasChanges = _this$props.setHasChanges,
        error = _this$props.error;
      var isCustomLabel = this.state.isCustomLabel;
      var buttonAddLabel = index === 0 ? labels.STEP_ADD_DEFAULT_LABEL : labels.STEP_ADD_STEP_LABEL;
      var buttonRemoveLabel = index === 0 ? labels.STEP_REMOVE_DEFAULT_LABEL : labels.STEP_REMOVE_STEP_LABEL;
      return /*#__PURE__*/_react["default"].createElement(_StepperMember["default"], {
        ruleIndex: index,
        labels: labels
      }, index > 1 && /*#__PURE__*/_react["default"].createElement(_StepperValueHeader["default"], {
        labels: labels,
        ruleIndex: index,
        actions: {
          deleteRuleFormulas: removeStep
        },
        setHasChanges: setHasChanges
      }), /*#__PURE__*/_react["default"].createElement(_BlockSubtitle["default"], {
        className: "stepper-block-title"
      }, index === 0 ? labels.STEP_DEFAULT : labels.STEP_INDEX.replace('%index%', index), /*#__PURE__*/_react["default"].createElement(_button.Button, {
        className: "stepper-label-toggle",
        type: "link",
        action: isCustomLabel ? this.onCustomLabelRemove : this.onCustomLabelAdd
      }, isCustomLabel ? buttonRemoveLabel : buttonAddLabel)), /*#__PURE__*/_react["default"].createElement("div", {
        className: "stepper-input-group"
      }, isCustomLabel && /*#__PURE__*/_react["default"].createElement("div", {
        className: "stepper-input-container"
      }, /*#__PURE__*/_react["default"].createElement(_input.Input, {
        onChange: this.onLabelChange,
        type: "text",
        placeholder: labels.STEP_DEFAULT_LABEL_PLACEHOLDER,
        value: data.label,
        errors: error && error.label
      }), /*#__PURE__*/_react["default"].createElement("span", {
        className: "stepper-input-separator"
      }, ":")), /*#__PURE__*/_react["default"].createElement("div", {
        className: "stepper-input-container"
      }, /*#__PURE__*/_react["default"].createElement(_input.Input, {
        onChange: this.onValueChange,
        type: "number",
        value: data.value,
        placeholder: labels.STEP_DEFAULT_VALUE_PLACEHOLDER,
        errors: error && error.value
      }))));
    }
  }]);
  return StepperMember;
}(_react["default"].Component);
StepperMember.__docgenInfo = {
  "description": "",
  "methods": [{
    "name": "onCustomLabelAdd",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "onCustomLabelRemove",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "onLabelChange",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "event",
      "type": null
    }],
    "returns": null
  }, {
    "name": "onValueChange",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "event",
      "type": null
    }],
    "returns": null
  }],
  "displayName": "StepperMember",
  "props": {
    "error": {
      "defaultValue": {
        "value": "{}",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "shape",
        "value": {
          "value": {
            "name": "string",
            "required": false
          },
          "label": {
            "name": "string",
            "required": false
          }
        }
      },
      "required": false
    },
    "labels": {
      "description": "",
      "type": {
        "name": "objectOf",
        "value": {
          "name": "string"
        }
      },
      "required": true
    },
    "index": {
      "description": "",
      "type": {
        "name": "number"
      },
      "required": true
    },
    "ruleChange": {
      "description": "",
      "type": {
        "name": "func"
      },
      "required": true
    },
    "data": {
      "description": "",
      "type": {
        "name": "shape",
        "value": {
          "value": {
            "name": "string",
            "required": false
          },
          "label": {
            "name": "string",
            "required": false
          }
        }
      },
      "required": true
    },
    "removeStep": {
      "description": "",
      "type": {
        "name": "func"
      },
      "required": true
    },
    "setHasChanges": {
      "description": "",
      "type": {
        "name": "func"
      },
      "required": true
    }
  }
};
var _default = StepperMember;
exports["default"] = _default;
StepperMember.defaultProps = {
  error: {}
};
StepperMember.propTypes = {
  labels: _propTypes["default"].objectOf(_propTypes["default"].string).isRequired,
  index: _propTypes["default"].number.isRequired,
  ruleChange: _propTypes["default"].func.isRequired,
  data: _propTypes["default"].shape({
    value: _propTypes["default"].string,
    label: _propTypes["default"].string
  }).isRequired,
  error: _propTypes["default"].shape({
    value: _propTypes["default"].string,
    label: _propTypes["default"].string
  }),
  removeStep: _propTypes["default"].func.isRequired,
  setHasChanges: _propTypes["default"].func.isRequired
};